var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.9536 12.7499H14.9055C14.7675 13.2861 14.485 13.7644 14.1019 14.1406L15.6262 16.7807C16.8809 15.8275 17.7489 14.3917 17.9536 12.7499ZM14.3277 17.5318L12.8032 14.8913C12.5476 14.9621 12.2782 15 12 15C11.7218 15 11.4524 14.9621 11.1967 14.8912L9.6722 17.5317C10.388 17.8333 11.1745 18 12 18C12.8255 18 13.612 17.8333 14.3277 17.5318ZM8.37379 16.7806L9.89806 14.1405C9.515 13.7643 9.23247 13.2861 9.09448 12.7499H6.0464C6.2511 14.3917 7.11911 15.8275 8.37379 16.7806ZM17.9536 11.2499H14.9055C14.7674 10.7137 14.4849 10.2355 14.1018 9.85938L15.6261 7.21928C16.8808 8.1724 17.7488 9.60814 17.9536 11.2499ZM14.3277 6.46822C13.6119 6.16668 12.8254 6 12 6C11.1746 6 10.388 6.16669 9.67227 6.46824L11.1968 9.10874C11.4524 9.03787 11.7218 9 12 9C12.2782 9 12.5475 9.03787 12.8032 9.10873L14.3277 6.46822ZM9.89812 9.85942L8.37385 7.21931C7.1192 8.17244 6.25119 9.60816 6.04644 11.2499H9.09455C9.23257 10.7137 9.51509 10.2356 9.89812 9.85942Z",
    fill: "url(#paint0_linear_10700_34916)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10700_34916",
    x1: 13.2971,
    y1: 2,
    x2: 13.2971,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerch);
export default __webpack_public_path__ + "static/media/merch.f5de5da5fb7aaf24f644c06d172d9a8a.svg";
export { ForwardRef as ReactComponent };